const banner = {
  alert: {
    backgroundColor: 'red.50'
  },
  warning: {
    backgroundColor: 'yellow.10'
  },
  notice: {
    backgroundColor: 'green.20'
  },
  white: {
    backgroundColor: 'white'
  }
};

export default banner;
